// import Vue from 'vue'
import {
  castArray,
  capitalize,
  error,
  isDateish,
  isFunction,
  uniqueArray,
} from '../views/utils'

export function buildGetCheck(mod, list, context) {
  const { getCheck } = mod
  if (!getCheck) {
    return Promise.reject(error(`No shallow cache check for ${mod.storeSuffix}`))
  }

  // array without duplicate elements
  return ids =>
    uniqueArray(ids).reduce((acc, id) => {
      const getCheckKey = isFunction(getCheck)
        ? getCheck(list[id], context)
        : getCheck

      let exists = typeof list[id] !== 'undefined'

      if (exists) {
        if (isFunction(getCheckKey)) {
          exists = getCheckKey(list[id])
        } else {
          exists = typeof list[id][getCheckKey] !== 'undefined'
        }
      }

      acc[exists ? 'exist' : 'fetch'].push(id)
      return acc
    }, {
      exist: [],
      fetch: [],
    })
}

// TODO: recursive
const globalImporter = (result) => {
  // typecast all date strings to Date
  const datelike = Object
    .keys(result)
    .filter(key => isDateish(result[key]))
    .reduce((acc, key) => ({
      ...acc,
      [key]: new Date(result[key]),
    }), {})

  return {
    ...result,
    ...datelike,
  }
}

export function filterExport(data, exportFn) {
  if (!data) return data

  const formattedData = castArray(data).map(exportFn)

  return typeof data === 'object'
    ? formattedData[0]
    : formattedData
}

export function filterImport(results, importFn) {
  const resultsAfterGlobalFilter = castArray(results).map(globalImporter)

  return importFn
    ? resultsAfterGlobalFilter.map(importFn)
    : resultsAfterGlobalFilter
}

export function getPaginationString({ $limit, $skip }) {
  return `${$limit || 20}|${$skip || 0}`
}

export function getServiceArguments({ id = null, ...data } = {}) {
  const params = {}
  const { query, data: innerData } = data

  if (id === null && query && innerData) {
    Object.assign(params, { query })
    data = innerData
  }

  return [id, data, params]
}

export const handleError = mod => stateActions => err => {
  // catch timeout
  if (err.message.startsWith('Timeout of')) {
    stateActions.dispatch('SET_ONLINE', false)
  } else if (!mod || !mod.storeSuffix || mod.storeSuffix !== 'ERRORS') {
    // do not throw recurisively throw errors for errors
    if (err && err.message === 'Unexpected token < in JSON at position 0') {
      err.message = 'Accountaboard API is down'
    }

    stateActions.dispatch('ERROR', err)
  }

  return Promise.reject(err)
}

export function getResults(res) {
  if (!res) return false

  if (res.data) {
    return castArray(res.data)
  }

  return castArray(res)
}

// export function prepareResolution(res, results) {
//   if (!res._) return res

//   return {
//     ...res._,
//     ...res,
//   }
// }

export function pullFromState(list, ids) {
  return castArray(ids).map(id => list[id])
}

export const manipulations = {
  add: ({ storeKey, storeSuffix }) => (results, { commit, getters }, doUseImportFn = true) => {
    const formatedResults = doUseImportFn
      ? filterImport(results, getters[`_import${capitalize(storeKey)}`])
      : results

    commit(`ADD_${storeSuffix}`, formatedResults)
  },

  remove: ({ storeSuffix }) => (results, { commit }) =>
    commit(`REMOVE_${storeSuffix}`, results),
}

// export function performRollback({ commit }, storeSuffix, rollback) {
//   // rough rollback
//   if (typeof rollback[Object.keys(rollback)[0]] === 'undefined') {
//     manipulations.remove(storeSuffix)(rollback, commit)
//   } else {
//     manipulations.add(storeSuffix)(rollback, commit)
//   }
// }

export function genId() {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)
}

// export function markAsOptimistic(entry) {
//   if (!entry.id) {
//     entry.id = genId()
//     entry._randomId = true
//     entry.createdAt = new Date()
//     entry.updatedAt = new Date()
//   }

//   return entry
// }

// function swapValuesIn(list, oldValue, newValue) {
//   const array = Array.isArray(list) ? list : Object.values(list)

//   array.forEach((entry) => {
//     Object
//       .keys(entry)
//       .filter(key => entry[key] === oldValue)
//       .forEach((key) => {
//         entry[key] = newValue
//       })
//   })
// }

// TODO: make applicable for multiple reflections and multiple results
// export function propageIdSwap(state, storeKey, reflections, results) {
//   const reflectionsWithRandomIds = reflections
//     .filter(reflection => reflection._randomId)

//   if (!reflectionsWithRandomIds.length) return

//   const randomId = reflectionsWithRandomIds[0].id
//   const newId = results[0].id

//   // change IDs to the new one
//   Object
//     .keys(state)
//     .forEach((key) => {
//       if (!state[key].list) return

//       swapValuesIn(state[key].list, randomId, newId)
//     })

//   swapValuesIn(state.queue.map(queueRecord => queueRecord.data), randomId, newId)

//   // remove redundant records
//   Vue.delete(state[storeKey].list, randomId)
// }



// WEBPACK FOOTER //
// ./src/store/utils.js